import { ref } from "vue";
import store from "../../store";
import {
  HubConnectionBuilder,
  HttpTransportType,
  LogLevel,
} from "@microsoft/signalr";

export const signalRSymbol = Symbol("signalr");

const getApiBaseUrl = () => {
  return store.apiBaseUrl || '';
};

const buildConnection = (baseUrl) => {
  if (!baseUrl) return null;
  return new HubConnectionBuilder()
    .withUrl(baseUrl + '/gamificationhub', {
      skipNegotiation: true,
      transport: HttpTransportType.WebSockets,
      accessTokenFactory: () => store.user?.access_token
    })
    .configureLogging(LogLevel.Information)
    .build();
};

const createSignalRConnection = () => ({
  connectionStarted: ref(false),
  connection: null
});

const attachHandlers = (signalrConnection) => {
  if (!signalrConnection.connection) return;
  signalrConnection.connection.onclose(() => {
    signalrConnection.connectionStarted.value = false;
    startConnection(signalrConnection);
  });
};

export const startConnection = (signalrConnection) => {
  if (!signalrConnection.connection) {
    const baseUrl = getApiBaseUrl();
    signalrConnection.connection = buildConnection(baseUrl);
    if (!signalrConnection.connection) return null;
    attachHandlers(signalrConnection);
  }
  signalrConnection.connection.start()
    .then(() => {
      signalrConnection.connectionStarted.value = true;
    })
    .catch(() => {
      signalrConnection.connectionStarted.value = false;
      setTimeout(startConnection(signalrConnection), 5000);
    })
  return signalrConnection.connection;
};


export default {
    install: (app) => {
        const signalrConnection = createSignalRConnection();

        app.provide(signalRSymbol, signalrConnection);
    }
  }
  